import { useIntl } from "react-intl";

const DependencyMapping = () => {
    const intl = useIntl();

    const messages = {
        header: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.DependencyMapping.header",
            defaultMessage: "Dependency mapping"
        }),
        body: intl.formatMessage({
            id: "JiraServiceManagementPricingPage.features.DependencyMapping.body",
            defaultMessage:
                "View the dependencies between configuration items or assets and services to assess the risk of changes, resolve incidents, and uncover the root cause of problems."
        })
    };

    return (
        <>
            <h2>{messages.header}</h2>
            <p>{messages.body}</p>
        </>
    );
};

export default DependencyMapping;
